import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router";

import { useMedia } from "@hooks/useMedia";
import { useStores } from "@stores";

import { HomeDesktopLayout } from "./HomeDesktopLayout";
import { HomeMobileLayout } from "./HomeMobileLayout";

export const Home = observer(() => {
  const { marketStore } = useStores();
  const { desktop } = useMedia();

  const params = useParams();

  useEffect(() => {
    marketStore.setRequiredMarketId(params.marketId ?? null);
    marketStore.setActiveMarket(marketStore.allMarkets.find((market) => market.symbol === params.marketId) ?? null);
  }, [params.marketId]);

  const isValidMarket = marketStore.allMarkets.some((market) => market.symbol === params.marketId);

  if (marketStore.allMarkets.length > 0 && !isValidMarket) {
    const firstMarket = marketStore.allMarkets[0];
    return <Navigate to={`/trades/${firstMarket.symbol}`} replace />;
  }

  return desktop ? <HomeDesktopLayout /> : <HomeMobileLayout />;
});
